import moment from 'moment-timezone';
import { DEFAULT_WEEK_START } from '../constants/date';
import { DEFAULT_LANGUAGE } from '../locale/locale';
import { getWeekday } from './formatter';
export var WEEK_LENGTH = 7;
export var WEEKS_PER_CALENDAR_MONTH = 6;
export var getCalendarMonth = function (date, weekStartDay) {
    if (weekStartDay === void 0) { weekStartDay = DEFAULT_WEEK_START; }
    var monthStartDay = date.clone().startOf('month');
    var monthStartWeekDay = monthStartDay.day();
    var iteratedDate = monthStartDay
        .clone()
        .add(monthStartWeekDay >= weekStartDay ? weekStartDay - monthStartWeekDay : weekStartDay - monthStartWeekDay - 7, 'days');
    var calendarWeeks = [];
    for (var week = 1; week <= 6; week++) {
        var calendarWeek = [];
        for (var weekDay = 1; weekDay <= WEEK_LENGTH; weekDay++) {
            calendarWeek.push({
                date: iteratedDate,
                day: iteratedDate.date(),
                weekDay: iteratedDate.day(),
                isCurrentMonth: monthStartDay.isSame(iteratedDate, 'month'),
                today: iteratedDate.isSame(moment(), 'day'),
                past: iteratedDate.isBefore(moment()),
            });
            iteratedDate = iteratedDate.clone().add(1, 'day');
        }
        calendarWeeks.push(calendarWeek);
    }
    return calendarWeeks;
};
export var getCalendarWeek = function (date, weekStartDay) {
    if (weekStartDay === void 0) { weekStartDay = DEFAULT_WEEK_START; }
    var currentWeekDay = date.day();
    var weekStartDelta = (currentWeekDay + WEEK_LENGTH - weekStartDay) % WEEK_LENGTH;
    var startDate = date.clone().subtract(weekStartDelta, 'days');
    var result = [];
    var weekDay = weekStartDay;
    var iteratedDate = startDate.clone();
    for (var i = 0; i < WEEK_LENGTH; i++) {
        result.push({
            date: iteratedDate,
            day: iteratedDate.date(),
            weekDay: weekDay,
            isCurrentMonth: iteratedDate.isSame(date, 'month'),
            today: iteratedDate.isSame(moment(), 'day'),
            past: iteratedDate.isBefore(moment()),
        });
        weekDay = (weekDay + 1) % WEEK_LENGTH;
        iteratedDate = iteratedDate.clone().add(1, 'day');
    }
    return result;
};
export var getWeekDayNames = function (locale, weekStartDay) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    if (weekStartDay === void 0) { weekStartDay = DEFAULT_WEEK_START; }
    var weekDates = [moment().startOf('week')];
    for (var i = 1; i < 7; i++) {
        weekDates.push(weekDates[weekDates.length - 1].clone().add(1, 'day'));
    }
    var weekDayNames = weekDates.reduce(function (names, date) {
        names.push(new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date.toDate()));
        return names;
    }, []);
    // Rotate week to start as needed.
    var endOfWeek = weekDayNames.splice(0, weekStartDay);
    endOfWeek.forEach(function (day) { return weekDayNames.push(day); });
    return weekDayNames;
};
export var getTimeText = function (date, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' });
    return intl.format(date);
};
export var getFullMonthText = function (date, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long' });
    return intl.format(date);
};
export var getDayMonthText = function (date, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
    return intl.format(date);
};
export var getWeekdayLabel = function (weekday, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var date = new Date('2017-01-03T00:00:00');
    date.setDate(1 + weekday);
    return getWeekday(date, locale);
};
//# sourceMappingURL=date.js.map